


import { Router } from '@angular/router';

import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ResultData } from 'src/app/_models/ResultData';
import { FactService } from 'src/app/_services/fact.service';
@Component({
  selector: 'app-load-fact',
  templateUrl: './load-fact.component.html',
  styleUrls: ['./load-fact.component.css']
})
export class LoadFactComponent implements OnInit {


  loading=false
  noFileSelected=true
  myForm = new FormGroup({
    file: new FormControl('', [Validators.required]),
    fileSource: new FormControl('', [Validators.required])
  });

  constructor(private router:Router,private factService:FactService) {

   }
  get f() {
    return this.myForm.controls;
  }

  ngOnInit(): void {
  }
  onFileChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.myForm.patchValue({
        fileSource: file
      });
    }
  }

  submit() {
    this.loading=true
    const formData = new FormData();
    formData.append('myFile', this.myForm.get('fileSource').value);

    this.factService.saveFactTemplate(formData,0).subscribe({
      next: (data:ResultData) => {
        let templateId = data.rs.data['server_fact_id']
        this.router.navigate(["/admin/fact/show",templateId])
        this.loading=false
    }
      ,error: (err) => {
        console.error(err);
        this.loading=false
      }
    }
    )
  }

}
